<template>
    <!-- <div id="main-wrapper" class="calxHeight"> -->
      <div id="main-wrapper" class="calxHeight">
        <!-- Add deposit amount in demo case  -->
        <div v-if=" AddepsoitFund">
            <div class="mfp-bg animated zoomIn mfp-ready"></div>
            <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
                <div class="mfp-container mfp-s-ready mfp-inline-holder">
                    <div class="mfp-content">
                        <div id="fund-input" class="white-popup-block popup-content popup-small">
                            <div class="content t-white">
                                <div class="form-holder">
                                    <ul>
                                        <li >
                                            <div class="currency t-white">
                                                <label for="" class="t-white">{{$t("fund_index.add_funds")}}</label>
                                                <div class="position-relative w-100">
                                                    <input type="number" name="fund" placeholder="Enter deposit amount" v-model="deposit_amount"/>
                                                  <div class="cur">
                                                    {{store.lastSelectedAccount.currency}}
                                                </div>
                                                   
                                                  </div>
                                                <span class="text-danger" v-if="submitted && error.amount">{{ error.amount }}</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="btn-holder t-center">
                                <a href="#" class="btn btn-yellow close-popup" @click.prevent="AddepsoitFund = false">{{$t("fund_index.cancel")}} </a>
                                <a href="#" class="btn btn-lblue popup-link-holder" @click.prevent="addDemoFunds()">{{$t("fund_index.ok")}} </a>
                            </div>
                             <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="AddepsoitFund = false">×</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="success">
          <div class="mfp-bg animated zoomIn mfp-ready"></div>
          <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
            <div class="mfp-container mfp-s-ready mfp-inline-holder">
              <div class="mfp-content">
                <div id="upload-confirm" class="white-popup-block popup-content popup-small">
                  <div class="content t-white t-center">
                    <p>{{$t("fund_index.your_request_to_add")}} {{static_vars.currency[store.lastSelectedAccount.currency]}} {{deposit_amount}} {{$t("fund_index.to_your_demo_account_number")}} {{store.lastSelectedAccount.account_id}} {{$t("fund_index.has_been_successfully_completed")}}.</p>
                    <!-- <SuccessBox
                        type="withdrawal"
                      /> -->
                  </div>
                  <div class="btn-holder t-center">
                    <a href="#" class="btn btn-lblue close-popup" @click.prevent="CheckDeposit(store.lastSelectedAccount.account_id);success = false">{{$t("fund_index.ok")}} </a>
                  </div>
                  <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="CheckDeposit(store.lastSelectedAccount.account_id);success = false">×</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="withdrawsuccess">
          <div class="mfp-bg animated zoomIn mfp-ready"></div>
          <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
            <div class="mfp-container mfp-s-ready mfp-inline-holder">
              <div class="mfp-content">
                <div id="upload-confirm" class="white-popup-block popup-content popup-small">
                  <div class="content t-white t-center">
                    <p>{{$t("fund_index.your_request_to_withdraw")}} {{static_vars.currency[store.lastSelectedAccount.currency]}} {{store.withdrawalAmount}} {{$t("fund_index.to_your_demo_account_number")}} {{store.lastSelectedAccount.account_id}} {{$t("fund_index.has_been_successfully_completed")}}.</p>
                    <!-- <SuccessBox
                        type="withdrawal"
                      /> -->
                  </div>
                  <div class="btn-holder t-center">
                    <a href="#" class="btn btn-lblue close-popup" @click.prevent="CheckDeposit(store.lastSelectedAccount.account_id);withdrawsuccess = false">{{$t("fund_index.ok")}} </a>
                  </div>
                  <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="CheckDeposit(store.lastSelectedAccount.account_id);withdrawsuccess = false">×</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="store.trans_id && store.trans_id_type == 'withdrawal'">
          <div class="mfp-bg animated zoomIn mfp-ready"></div>
          <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
            <div class="mfp-container mfp-s-ready mfp-inline-holder">
              <div class="mfp-content">
                <div id="upload-confirm" class="white-popup-block popup-content popup-small">
                  <div class="content t-white t-center">
                    <p>{{$t("fund_index.your_request_to_withdraw")}} {{static_vars.currency[store.lastSelectedAccount.currency]}}{{store.withdrawalAmount}} {{$t("fund_index.from_the_trading_id")}} {{store.lastSelectedAccount.account_id }} {{$t("fund_index.has_been_received")}}. {{$t("fund_index.click_to_proceed_withdrawal")}}.</p>
                    <SuccessBox
                        type="withdrawal"
                      />
                  </div>
                  <!-- <div class="btn-holder t-center">
                    <a href="#" class="btn btn-lblue close-popup" @click.prevent="backFromWithdraw">OK </a>
                  </div> -->
                  <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="backFromWithdraw">×</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="message">
          <div class="mfp-bg animated zoomIn mfp-ready"></div>
          <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
            <div class="mfp-container mfp-s-ready mfp-inline-holder">
              <div class="mfp-content">
                <div id="upload-confirm" class="white-popup-block popup-content popup-small">
                  <div class="content t-white t-center">
                    <p v-if="msgType == 'success'">{{$t("fund_index.your_request_to_withdraw")}} {{static_vars.currency[message.to_currency]}} {{message.amount}} {{$t("fund_index.from_the_trading_id")}} {{message.account_id}} {{$t("fund_index.has_been_successfully")}}.</p>
                    <p v-else>{{message}}</p>
                  </div>
                  <div class="btn-holder t-center">
                    <a href="#" class="btn btn-lblue close-popup" @click.prevent="message = ''">{{$t("fund_index.ok")}} </a>
                  </div>
                  <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="message = ''">×</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="store.trans_id && store.trans_id_type == 'INTERNAL TRANSFER'">
          <div class="mfp-bg animated zoomIn mfp-ready"></div>
          <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
            <div class="mfp-container mfp-s-ready mfp-inline-holder">
              <div class="mfp-content">
                <div id="upload-confirm" class="white-popup-block popup-content popup-small">
                  <div class="content t-white ">
                    <p>{{$t("fund_index.your_request_to_add_usd")}} {{deposit_amount}} to your Demo Account Number {{store.lastSelectedAccount.account_id}} {{$t("fund_index.has_been_successfully_completed")}}.
                    </p>
                  </div>
                  <div class="btn-holder t-center">
                    <a href="#" class="btn btn-lblue close-popup" @click.prevent="resetAndBack">{{$t("fund_index.ok")}} </a>
                  </div>
                  <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="resetAndBack">×</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-container profile-page deposit-live" :class="(fundType == 'Withdrawals')?'transactions-dep':''">
            <div class="page-wrap">
                <div class="page-content clearfix">
                    <div class="main-content f-left">
                        <div class="nav-holder">
                            <ul>
                                <li v-for="type of filterFundTypes" :key="type">
                                    <button @click="setFundType(type)" class="btn" :class="fundType == type ? 'btn-yellow' : 'btn-blue'">
                                        {{ type }}
                                    </button>
                                </li>
                            </ul>
                        </div>{{checkFund}}
                        <Deposit v-if="fundType == 'Deposits'" ref="deposit" />
                        <Withdrawal v-if="fundType == 'Withdrawals'" ref="withdrawal"/>
                        <Transactions v-if="fundType == 'Transactions'" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { useMainStore } from "@/store";
import Deposit from "@/views/funds/deposit";
import Withdrawal from "@/views/funds/withdrawal";
import Transactions from "@/views/funds/transactions";
import SuccessBox from "@/components/shared/SuccessBox";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  components: { Deposit, Withdrawal, Transactions,SuccessBox},
  data() {
    return {
      fundTypes: ["Deposits", "Withdrawals", "Transactions"],
      fundType: "Deposits",
      AddepsoitFund : false,
      deposit_amount :'',
      submitted :false,
      error: {
        account: null,
        amount: null,
      },
      message : '',
      msgType : '',
      operation : 'WITHDARWAL',
      success : false,
      withdrawsuccess : false

    };
  },
  updated(){
    if(!this.filterFundTypes.includes(this.fundType)){
      /* eslint-disable-next-line */
      this.fundType = this.filterFundTypes[0]
    }
  },
  computed:{
    filterFundTypes(){
      let role = (this.store.user.roles || '').split('&') || []
      return this.fundTypes.filter(v=>{
        return  (v == 'Deposits')?
                  (!role.includes('CB') && !role.includes('DBL')):
                (v == 'Withdrawals')?
                  (!role.includes('CB') && !role.includes('WBL')):true
          /*role.includes('CB')?
                  !['Deposits','Withdrawals'].includes(v):
                role.includes('DBL')?
                  !['Deposits'].includes(v):
                role.includes('WBL')?
                  !['Withdrawals'].includes(v) :true*/
      })
    },
    checkFund(){
      if(!this.filterFundTypes.includes(this.fundType)){
        /* eslint-disable-next-line */
        this.fundType = this.filterFundTypes[0]
      }
      return ''
    }
  },
  methods: {
    CheckDeposit(id){
      let account = this.store.tradingAccounts.records.filter(
        (i) => i.account_id === id
      );
      let keys = {
        dataRequired: {
          margin_detail: true,
          open_trades: false,
          history: false,
          account_detail: false,
        },
      };
      this.store.setLastSelectedAccount(account[0],keys,false,'');
      this.store.$patch({ withdrawalAmount: null });
    },
    setFundType(e) {
      this.fundType = e;
    },
    resetAndBack(){
         this.store.$patch({ trans_id: null });
    },
    backFromWithdraw(){
      this.store.$patch({ trans_id: null });
      this.store.$patch({ withdrawalAmount : null})
      this.fundType = 'Deposits'
    },
    addDemoFunds(){
        if(this.deposit_amount != '' && this.deposit_amount > 0){
            this.submitted = false
            let form = {
            account_id: this.store.lastSelectedAccount.account_id,
            act_account_id: this.store.lastSelectedAccount.act_account_id,
            amount: this.deposit_amount.toString(),
            comment: "deposit"
          };
            this.store.startDemoFunding(form, true,this);
        }else{
            this.submitted = true 
            this.error.amount = 'Amount is required.'
        }
    },
    verify() {
      let form = {
        type: this.operation,
        google_token: this.google_token,
        trans_id: `${this.store.trans_id}`,
      };
      this.store.verifyAccountOperation(form, true).then(response => {
        //modal show
        this.store.$patch({ withdrawalAmount: null });
        this.store.$patch({ trans_id: null });
        this.message = response
        this.msgType = 'success'
        //this.changeToAccount(response.account_id)
      }).catch(error => {
        this.store.$patch({ withdrawalAmount: null });
        this.store.$patch({ trans_id: null });
        this.message = error
        this.msgType = 'error'
      })
    },
  },
  created(){
        if(this.$route.query.from && this.$route.query.from == 'google-auth'){
            this.fundType = 'Withdrawals'
            this.$router.replace({query: null})
        }
        if(this.$route.query.from && this.$route.query.from == 'verifyWithdrawal'){
          this.fundType = 'Transactions'
            this.$router.replace({query: null})
        }
        if(this.$route.query.fundType && this.$route.query.fundType == 'Withdrawals'){
          this.fundType = 'Withdrawals'
            this.$router.replace({query: null})
        }
    },
};
</script>
